import React from "react";
import styles from "./Checkbox.module.css";

export default function Checkbox(props) {
  const {
    checkClass = "check",
    className,
    checked,
    tipo = "",
    name,
    onChange,
    colorScheme,
    radio,
    style,
    semiChecked = false,
  } = props;

  return (
    <label
      className={`${styles.Checkbox} ${className ? className : ""}`}
      colorScheme={colorScheme}
      onClick={ev => {
        ev.stopPropagation();
      }}
    >
      <input type="checkbox" checked={checked} name={name} onChange={onChange} {...props} />
      <div
        checked={checked}
        className={checkClass + tipo}
        data-radio={radio}
        style={style}
        data-semiChecked={semiChecked}
      >
        {(!!checked || !!semiChecked) && (
          <svg viewBox="0 0 24 24">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        )}
      </div>
    </label>
  );
}
